export const BLOG_POSTS = [
    {
        id: 'vehicle-routing-problem',
        title: 'Review of Vehicle Routing Problem',
        category: 'Research',
        excerpt: 'Study and implementation of techniques like Tabu Search Algorithms, Genetic and Heuristic Algorithms, Greedy and Dijkstra\'s Algorithms to solve VRP with multiple constraints.',
        date: '2017',
        readTime: 'Research Paper',
        link: 'https://ieeexplore.ieee.org/abstract/document/8056881',
    },
];
